import { stringifyQueryParams } from 'utils'

import { diversioApiV2 } from 'api/axios/axiosInstance'
import { endpoints } from 'api/endpoints'
import { downloadFile } from '../sharedActions'

import {
    ClosePulseSurveyParams,
    ClosePulseSurveyResponse,
    CreatePulseSurveyPayload,
    CreatePulseSurveyResponse,
    DeletePulseSurveyPayload,
    DuplicatePulseSurveyFromTemplatePayload,
    DuplicatePulseSurveyFromTemplateResponse,
    DuplicatePulseSurveyPayload,
    DuplicatePulseSurveyResponse,
    GetPulseSurveyCollectorInfoParams,
    GetPulseSurveyCollectorInfoResponse,
    GetPulseSurveyCSVDownloadParams,
    GetPulseSurveyDetailParams,
    GetPulseSurveyDetailResponse,
    GetPulseSurveyFreeTextResultsParams,
    GetPulseSurveyFreeTextResultsResponse,
    GetPulseSurveyResultsParams,
    GetPulseSurveyResultsResponse,
    GetPulseSurveysResponse,
    GetPulseSurveysTemplatesParams,
    GetPulseSurveysTemplatesResponse,
    PublishPulseSurveyParams,
    PublishPulseSurveyResponse,
    UpdatePulseSurveyPayload,
    UpdatePulseSurveyResponse,
} from './pulseSurveysActions.types'

export const getPulseSurveys = async (): Promise<GetPulseSurveysResponse> => {
    const response = await diversioApiV2.get(endpoints.pulseSurveys.list)

    return response.data
}

export const getPulseSurveyDetail = async ({
    surveyUUID,
}: GetPulseSurveyDetailParams): Promise<GetPulseSurveyDetailResponse> => {
    const response = await diversioApiV2.get(endpoints.pulseSurveys.detail(surveyUUID))

    return response.data
}

export const getPulseSurveysTemplates = async (
    params?: GetPulseSurveysTemplatesParams,
): Promise<GetPulseSurveysTemplatesResponse> => {
    const response = await diversioApiV2.get(endpoints.pulseSurveys.templates, {
        params,
        paramsSerializer: (params) => stringifyQueryParams(params),
    })

    return response.data
}

export const createPulseSurvey = async (body?: CreatePulseSurveyPayload): Promise<CreatePulseSurveyResponse> => {
    const response = await diversioApiV2.post(endpoints.pulseSurveys.create, body)

    return response.data
}

export const duplicatePulseSurveyFromTemplate = async (
    body: DuplicatePulseSurveyFromTemplatePayload,
): Promise<DuplicatePulseSurveyFromTemplateResponse> => {
    const response = await diversioApiV2.post(endpoints.pulseSurveys.duplicateSurveyFromTemplate, body)

    return response.data
}

export const duplicatePulseSurvey = async (
    body: DuplicatePulseSurveyPayload,
): Promise<DuplicatePulseSurveyResponse> => {
    const response = await diversioApiV2.post(endpoints.pulseSurveys.duplicate, body)

    return response.data
}

export const updatePulseSurvey = async ({
    surveyUUID,
    body,
}: UpdatePulseSurveyPayload): Promise<UpdatePulseSurveyResponse> => {
    const response = await diversioApiV2.patch(endpoints.pulseSurveys.update(surveyUUID), body)

    return response.data
}

export const deletePulseSurvey = async ({ surveyUUID }: DeletePulseSurveyPayload): Promise<void> => {
    return await diversioApiV2.delete(endpoints.pulseSurveys.delete(surveyUUID))
}

export const publishPulseSurvey = async ({
    surveyUUID,
}: PublishPulseSurveyParams): Promise<PublishPulseSurveyResponse> => {
    const response = await diversioApiV2.post(endpoints.pulseSurveys.publish(surveyUUID))

    return response.data
}

export const closePulseSurvey = async ({ surveyUUID }: ClosePulseSurveyParams): Promise<ClosePulseSurveyResponse> => {
    const response = await diversioApiV2.post(endpoints.pulseSurveys.close(surveyUUID))

    return response.data
}

export const getPulseSurveyCollectorInfo = async ({
    surveyUUID,
}: GetPulseSurveyCollectorInfoParams): Promise<GetPulseSurveyCollectorInfoResponse> => {
    const response = await diversioApiV2.get(endpoints.pulseSurveys.collectorInfo(surveyUUID))

    return response.data
}
export const getPulseSurveyResults = async ({
    surveyUUID,
}: GetPulseSurveyResultsParams): Promise<GetPulseSurveyResultsResponse> => {
    const response = await diversioApiV2.get(endpoints.pulseSurveys.results(surveyUUID))

    return response.data
}

export const getPulseSurveyFreeTextResult = async (
    params: GetPulseSurveyFreeTextResultsParams,
): Promise<GetPulseSurveyFreeTextResultsResponse> => {
    const response = await diversioApiV2.get(
        endpoints.pulseSurveys.freeTextResults(params.surveyUUID, params.freeTextQuestionUUID ?? ''),
        {
            params,
            paramsSerializer: (params) => stringifyQueryParams(params),
        },
    )

    return response.data
}

export const getPulseSurveyCSVDownload = async (params: GetPulseSurveyCSVDownloadParams): Promise<void> => {
    await downloadFile(params, endpoints.pulseSurveys.download(params.surveyUUID))
}
